import React from "react";
import { Stack } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const PublicProfilePriveted = () => {
    return (
        <Stack direction="column" alignItems="center">
            <VisibilityOffIcon fontSize="large" />
            <p>This profile is private</p>
        </Stack>
    );
};

export default PublicProfilePriveted;
